import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "photo-album" }
const _hoisted_2 = {
  key: 0,
  class: "scan-photo"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "上一个", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "下一个", -1)
const _hoisted_6 = [
  _hoisted_5
]

import { getCurrentInstance, ref, Ref } from "vue";
import PhotoFrame from "@/components/PhotoFrame.vue";
import type { IPhoto } from "@/types/photo";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotoAlbum',
  props: {
    data: {
        type: Array,
        required: true,
    },
},
  setup(__props, { expose: __expose }) {

const instance = getCurrentInstance()?.proxy;

const props = __props;

const source = props.data as Array<IPhoto>;
let currentPhotoNumber: Ref<number> = ref(0);
let currentPhoto: Ref<IPhoto> = ref({ src: "", alt: "", title: "" });
let showScanPhoto: Ref<boolean> = ref(false);

function getBounds() {
    const rect = instance?.$el.getBoundingClientRect();
    return {
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        right: rect.right,
        bottom: rect.bottom,
    };
}

function closeScanPhoto() {
    showScanPhoto.value = false;
}

function scanPhoto(index: number) {
    index = Math.max(0, Math.min(source.length - 1, index));
    showScanPhoto.value = true;
    currentPhotoNumber.value = index;
    const photo: IPhoto = source[index];
    let photoSize = photo.src.match(/\d+x\d+/)?.[0];
    if (photo) {
        if (window.innerWidth < window.innerHeight) {
            photoSize = "768x1280";
        } else {
            photoSize = "1920x1080";
        }
        currentPhoto.value = Object.assign({}, photo, { src: photo.src.replace(/\d+x\d+/, photoSize) });
    } else {
        closeScanPhoto();
    }
}

__expose({ getBounds });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(source), (item, index) => {
      return (_openBlock(), _createBlock(PhotoFrame, {
        key: item.src,
        onClick: ($event: any) => (scanPhoto(index)),
        src: item.src,
        alt: item.alt,
        title: item.title
      }, null, 8, ["onClick", "src", "alt", "title"]))
    }), 128)),
    (_unref(showScanPhoto))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(PhotoFrame, {
            src: _unref(currentPhoto).src,
            alt: _unref(currentPhoto).alt,
            title: _unref(currentPhoto).title
          }, null, 8, ["src", "alt", "title"]),
          _createElementVNode("div", {
            class: "close",
            onClick: closeScanPhoto
          }, "关闭"),
          _createElementVNode("div", {
            class: "preve",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (scanPhoto(_isRef(currentPhotoNumber) //@ts-ignore
 ? --currentPhotoNumber.value : --currentPhotoNumber)))
          }, _hoisted_4),
          _createElementVNode("div", {
            class: "next",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (scanPhoto(_isRef(currentPhotoNumber) //@ts-ignore
 ? ++currentPhotoNumber.value : ++currentPhotoNumber)))
          }, _hoisted_6)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})